import {
  LOAD_API_SERVICETYPES_INFO_DATA,
  LOAD_API_SERVICETYPES_INFO_DATA_FAILED,
  LOAD_API_SERVICETYPES_INFO_DATA_SUCCESS,
} from "../types"

const initialState = {
  serviceTypes: [],
  loading: false,
  error: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case LOAD_API_SERVICETYPES_INFO_DATA:
      return {
        ...state,
        loading: true,
        error: false,
        serviceTypes: [],
      }
    case LOAD_API_SERVICETYPES_INFO_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        serviceTypes: [],
      }
    case LOAD_API_SERVICETYPES_INFO_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        serviceTypes: action.payload,
      }
    default:
      return state
  }
}
